import React from 'react'
import {StripeBG, Icon} from '../../components'
import {Navbar} from '../../components/marketing'
import {DocToc} from '../../components/blog'

class Overview extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="DocPage">
        <StripeBG bg2={"white"} style="purple"/>
        <Navbar className="grid-restrain"/>
        <section className="grid-restrain grid-row full-8">
          <DocToc />
          <div className="content markdown-doc grid-item">
            <h1 className="title">Flow Control</h1>
            <div>
              <p>Using Flow Control, you can add statements for decision making and error handling within your tests.</p>

              <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1532872070/docs/Flow%20Control/Screen_Shot_2018-07-10_at_8.47.17_PM.png" style={{"max-width": "400px"}} /></p>

              <p>A use case is to scrape data.</p>

              <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1532873873/docs/Flow%20Control/Screen_Shot_2018-07-29_at_9.17.28_AM.png" style={{"max-width": "400px"}} /></p>

              <p>Then export the results to CSV or jSON.</p>

              <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1532872070/docs/Flow%20Control/Screen_Shot_2018-07-05_at_11.00.13_PM.png" style={{"max-width": "400px"}} /></p>

              <p>You can indent and un-indent actions for better visualization.</p>
              <ul>
                <li>Select the action or actions.</li>
                <li>Click indent or un-indent.</li>
              </ul>
              <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1533088748/docs/Indenting/Screen_Shot_2018-07-31_at_8.58.53_PM.png" style={{"max-width": "400px"}} /></p>
            </div>
          </div>
        </section>
      </div>
    )
  }

}

export default Overview;



// WEBPACK FOOTER //
// ./src/pages/doc/flow-control.js